<div id="crop-health-note-view">
  <p class="page-title">
    <i class="ph-bold ph-caret-left back-icon" (click)="onBackBtn()"></i>
    <span>{{ 'doktar_app.services.crop_monitoring.note_detail' | translate }}</span>
  </p>

  @if (note) {
    <app-crop-health-note-item
      [note]="note"
      [showFullContent]="true"
      (getAllNotes)="getAllNotes.emit()" />
  }
</div>
